<script>
export const pageName = 'club-edit';
export const pageRoute = '/clubs/{clubId}/edit';
export const title = 'Edit Club'
export const requireMembership = true;

import Modal from '../../js/utils/modal.js';
import Cropper from 'cropperjs'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { navigate } from '@trullock/page-manager'
import { commands } from '../../js/lib/functions.js';
import { showToast } from '../../js/utils/toast.js'
import { getClubView } from '../../js/readModel.js';
import { resize } from '../../js/utils/resizer.js';

export default {
	data() {
		return { 
			acronym: null,
			name : null,
			url: null,
			notes: null,
			lat: 0,
			lng: 0,
			logo: null,
			isDirty: false,
			ready: false
		}
	},

	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async boot(opts) {
			this.modal = new Modal(this.$refs.cropper);
		},
		async show(opts) {
			
			commands.warmUp.clubUpdate();
			
			this.$refs.fupLogo.setCustomValidity('');

			this.club = await getClubView(opts.clubId)

			this.acronym = this.club.acronym;
			this.name = this.club.name
			this.url = this.club.url
			this.notes = this.club.notes
			this.lat = this.club.coords?.lat
			this.lng = this.club.coords?.lng
			this.logo = this.club.logoUrl;			
			this.isDirty = false;

			this.ready = true;
		},
		changed() {
			this.isDirty = true;
		},
		async submit () {
			showLoading();

			let result = await commands.clubUpdate({ 
				clubId: this.club.id,
				acronym: this.acronym,
				name: this.name,
				url: this.url,
				lat: parseFloat(this.lat || '0') || null,
				lng: parseFloat(this.lng || '0') || null,
				notes: this.notes,
				logo: this.logo
			});

			if(!result.success)
			{
				showToast({ message: 'Error editing club', style: 'bg-danger'})
				hideLoading();
				return;
			}

			this.isDirty = false;

			navigate(`/clubs/${this.club.id}`)

			showToast({
				message: 'Club updated',
				style: 'bg-success'
			})

			hideLoading();
		},
		
		logoAdded(e) {
			var files = e.target.files;

			this.$refs.fupLogo.setCustomValidity('');
			this.$refs.fupLogo.reportValidity();

			if (files && files.length > 0) {
				let file = files[0];

				this.$refs.fupLogo.value = '';
				this.$refs.fupLogo.blobData = null;
				
				cropImage({
					aspectRatio: 1,
					viewMode: 1,
					autoCropArea: 1
				}, { 
					width: 480, 
					height: 480 
				}, file).then(canvas => {
					this.avatar = canvas.toDataURL();
					this.newAvatar = this.avatar;

					canvas.toBlob(blob => {
						this.$refs.fupLogo.blobData = {
							blob: blob,
							name: 'logo.jpg'
						};

						this.$refs.lblLogo.innerText = file.name;
					});
				}, e => {
					if(e instanceof Error)
					{
						this.$refs.fupLogo.setCustomValidity(e.message);
						this.$refs.fupLogo.reportValidity();
					}
				})
			}
		}
	}
}

</script>
<template>
	<div v-show="ready" class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-md-8 col-xl-6 my-5">
				<h1 class="display-4 text-center mb-3">Edit Club</h1>
				<p class="text-muted text-center mb-5">Update the details of your club.</p>
					
				<form @submit.prevent="submit" @change="changed">
					<div class="form-group">
						<label class="form-label">
							Acronym
						</label>
						<input type="text" class="form-control" v-model="acronym" placeholder="e.g. MRC" required autofocus>
						<span class="invalid-feedback mt-2 d-block"></span>
					</div>

					<div class="form-group">
						<label class="form-label">
							Name
						</label>
						<input type="text" class="form-control" v-model="name" placeholder="e.g. My Rocket Club" required>
						<span class="invalid-feedback mt-2 d-block"></span>
					</div>

					<div class="form-group">
						<label class="form-label">
							URL
						</label>
						<input type="text" class="form-control" v-model="url" placeholder="e.g. https://my-rocket-club.com/" required>
						<span class="invalid-feedback mt-2 d-block"></span>
					</div>

					<div class="row mb-2">
						<div class="col">https://www.midlandrocketry.org.uk/
						</div>
						<div class="col">
							<div class="form-group mb-0">
								<label class="form-label">Longitude</label>
								<input type="number" class="form-control" v-model="lng" step="0.0000001">
								<span class="invalid-feedback"></span>
							</div>
						</div>
					</div>

					<div class="field form-group">
						<label>
							Logo
							<div class="dz-default dz-message py-3" v-if="logo">
								<div class="avatar avatar-xxl">
									<img ref="imgAvatar" class="avatar-img" :src="logo" alt="Club logo">
								</div>
							</div>
						</label>
						<div class="custom-file">
							<input type="file" @change="logoAdded" ref="fupLogo" class="custom-file-input" accept="image/*;capture=camera">
							<label ref="lblLogo" class="custom-file-label text-muted">Choose image&hellip;</label>
							<span class="invalid-feedback"></span>
						</div>
						<span class="form-text text-muted small mb-0">Must be a jpeg or png.</span>
					</div>
					
					<div class="form-group">
						<label class="form-label mb-1">Notes</label>
						<textarea class="form-control" v-model="notes" rows="4"></textarea>
					</div>

					<button class="btn w-100 btn-primary">Save changes <span class="fe fe-check-circle"></span></button>
				</form>
			</div>
		</div>
    </div>
	
	<div class="modal fade" ref="cropper" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="card mb-0">
					<div class="card-header">
						<h4 class="card-header-title">Crop the image</h4>
						<button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body">
						<p>Your picture must be good quality and clearly legible.</p>
						<div class="img-container">
							<img ref="imgCropper" :src="logo" class="">
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" @click.prevent="hideModal">Cancel</button>
						<button type="button" class="btn btn-primary" @click.prevent="crop">Crop</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
